import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Footer, Navbar, Summary } from "../components";
import Whatsapp from "./whatsapp/Whatsapp";

const RootLayout = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <>
      <Summary />
      <Navbar />
      <Outlet />
      <Whatsapp />
      <Footer />
    </>
  );
};

export default RootLayout;
